import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsChevroletComponent } from './simple-icons-chevrolet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsChevroletComponent ],
    exports:      [ SimpleIconsChevroletComponent ],
    bootstrap:    []
})
export class SimpleIconsChevroletModule {}
